export const MUTATION_TYPES = {
  SET_LOADING: 'set-loading',
  SET_NOTIFICATION: 'set-notification',
};
